import { getters } from './getters'
import { actions } from './actions'
import { mutations } from './mutations'

const state = () => ({
  marketActiveTab: 'miniapp-market-fund',
  marketActiveTabChild: 'miniapp-market-gold-trader',
  positionScroll: 100,
  showFooter: true,
})

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
